import {
  TaskCategoryStage,
  TaskCategoryWorkflowType,
  type AutopilotTaskDto,
  type TaskStepDto,
} from '@urbanx/agx.activities.client';

export type TaskStepCompletionConfirmationVariant = 'condition' | 'lastCondition' | 'deposit';

export const shouldConfirmSingleStepCompletion = (taskSteps: TaskStepDto[], step: TaskStepDto) =>
  taskSteps.length === 1 && step.isCompleted !== true;

const isSameTask = (left: AutopilotTaskDto, right: AutopilotTaskDto) =>
  left.id !== undefined && left.id === right.id;

export const isLastIncompleteTaskInStage = ({
  task,
  tasks,
  stage,
  workflowType,
}: {
  task?: AutopilotTaskDto;
  tasks: AutopilotTaskDto[];
  stage: TaskCategoryStage;
  workflowType?: TaskCategoryWorkflowType;
}) => {
  if (!task) return false;

  const resolvedWorkflowType = workflowType ?? task.category?.workflowType;
  if (!resolvedWorkflowType) return false;

  const incompleteStageTasks = tasks.filter(
    (candidate) =>
      candidate.category?.workflowType === resolvedWorkflowType &&
      candidate.category?.stage === stage &&
      candidate.isCompleted !== true
  );

  return incompleteStageTasks.length === 1 && isSameTask(incompleteStageTasks[0], task);
};

export const getTaskStepCompletionConfirmationVariant = ({
  task,
  tasks,
  step,
}: {
  task: AutopilotTaskDto;
  tasks: AutopilotTaskDto[];
  step: TaskStepDto;
}): TaskStepCompletionConfirmationVariant | undefined => {
  const taskSteps = task.taskSteps ?? [];

  if (!shouldConfirmSingleStepCompletion(taskSteps, step)) return undefined;

  const { category } = task;
  if (!category) return undefined;

  if (
    category.stage === TaskCategoryStage.Deposits ||
    category.workflowType === TaskCategoryWorkflowType.Deposit
  ) {
    return 'deposit';
  }

  if (category.stage !== TaskCategoryStage.Conditions) return undefined;

  return isLastIncompleteTaskInStage({
    task,
    tasks,
    stage: TaskCategoryStage.Conditions,
  })
    ? 'lastCondition'
    : 'condition';
};
